<div class="wrapper">
  <section id="area-breadcrumb" class="area-top">
    <div class="container">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Home</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li>Contatos</li>
        </ul>
      </nav>
    </div>
  </section>

  <section id="contatos">
    <div class="container">
      <div class="columns">
        <div class="column is-offset-1 is-10">
          <img class="icon-montreal" src="assets/img/logo-contato.png" alt="montreal-viagens-logo-exclamacao" />
          <h1 class="title">Contatos</h1>
          <p>
            Fale conosco pelo chat aqui no site, pelo WhatsApp, telefone ou em nossas redes sociais!
            Nossa atendente virtual, está disponível todos os dias da semana.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="accordions" id="perguntas">
    <div class="container">
      <div class="columns">
        <div class="column is-10 is-offset-1">
          <a href="http://api.whatsapp.com/send?1=pt_BR&amp;phone=5561996863311" target="_blank"
            class="btn-verde-claro btn-social"><i class="fab fa-whatsapp"></i> 61 99686-3311</a>
          <br>

          <h5>Canais de Contato</h5>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-10" class="btn-control" />
            <label class="btn" for="btnControl-10">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Atendimento ao cliente <strong>0800 610 3311</strong>
                </p>
                <label class="area-check">
                  <p>
                    Marcação, alteração, revisão e cancelamento de reservas, consulta de saldo de diárias,
                    atualização cadastral, dúvidas relacionadas a reservas, segunda via de voucher, prorrogação,
                    antecipação, mudança de categoria, informações sobre hotéis e período de marcação.
                    <br>
                    <br>
                    <strong>Horário de Atendimento: 2ª a 6ª, das 9h às 18h.</strong>
                    <br>
                    Aos <span class="destacar">sábados</span> nosso atendimento é somente para suporte à hospedagem em assuntos relacionados à
                    problemas durante a hospedagem ou com reservas que apresentem divergência no check-in.
                    <br>
                    <br>
                    <strong>Horário de Atendimento: das 8h às 14h.</strong>
                    <br>
                    Operações com reservas também estão disponíveis pelo
                    <span class="destacar">
                      <a href="https://assinatura.viagensmontreal.com/novo-app-montreal" target="_blank">aplicativo Montreal Viagens</a>
                    </span>
                    ou pelo
                    <span class="destacar">
                      <a href="https://api.whatsapp.com/send?1=pt_BR&phone=5561996863311" target="_blank">WhatsApp em 6199686-3311</a>
                    </span>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-11" class="btn-control" />
            <label class="btn" for="btnControl-11">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Televendas <strong>0800 610 2200</strong>
                </p>
                <label class="area-check">
                  <p>
                    Nossos especialistas estão prontos para auxiliar na compra de planos de assinatura de hotéis.
                    Também poderão tirar dúvidas sobre o Clube e cadastrar indicações, bem como entrar
                    em contato com seus amigos indicados.
                    <br>
                    <br>
                    <strong>Horário de Atendimento: 2ª a 6ª, das 9h às 18h.</strong>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-12" class="btn-control" />
            <label class="btn" for="btnControl-12">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Ouvidoria <strong>0800 642 6633</strong>
                </p>
                <label class="area-check">
                  <p>
                    Se sua reclamação foi tratada em nossos canais de atendimento, mas a solução não foi
                    satisfatória, entre em contato com a ouvidoria da Montreal. Para isso, é necessário ter sido
                    atendido em um dos nossos canais de atendimento oficiais e nos informar o número
                    do protocolo.
                    <br>
                    <br>
                    <strong> Horário de Atendimento: 2ª a 6ª, das 9h às 18h, exceto feriados.</strong>
                  </p>
                </label>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-13" class="btn-control" />
            <label class="btn" for="btnControl-13">
              <div class="contatos">
                <p>
                  Cliente no exterior <strong>+55 61 3323-3311</strong>
                </p>
              </div>
            </label>
          </div>

          <div class=" div-filtro accordion">
            <input type="checkbox" id="btnControl-14" class="btn-control" />
            <label class="btn" for="btnControl-14">
              <div class="contatos">
                <p>
                  <i class="fas fa-chevron-down"></i>
                  Lei Geral de Proteção de Dados (LGPD) ou Política de Privacidade:
                  <strong *ngIf="!isMobile">
                    <a class="link-default" href="mailto:meusdados@viagensmontreal.com">meusdados@viagensmontreal.com</a>
                  </strong>
                  <br>
                  <small *ngIf="isMobile"><strong>meusdados@viagensmontreal.com</strong></small>
                  <small>Canal <strong>exclusivo</strong> para tratativas referentes à Lei Geral de Proteção de Dados (LGPD) ou à Política de Privacidade</small>
                </p>
                <label class="area-check">
                  <p>
                    Este canal é destinado aos titulares de dados cadastrados na Montreal Viagens e atua em
                    questões como: consulta, retificação ou exclusão de dados pessoais; reporte de tratamento
                    indevido de dados e esclarecimento de dúvidas referente à Política de Privacidade e/ou formas
                    de tratamento de dados. O prazo de resposta é de 10 dias úteis.
                  </p>

                </label>
              </div>
            </label>
          </div>



          <h5 class="contatos-section-title">Trabalhe Conosco</h5>

          <p class="nossa-central">Quer trabalhar em uma das melhores empresas do mercado de turismo do Brasil? Busque por vagas ou cadastre seu currículo com a gente.</p>
          <a href="https://clubemontreal.empregare.com/pt-br/vagas" class="btn-verde">QUERO TRABALHAR NA MONTREAL</a>

        </div>
      </div>
      <div class="chat contato">
        <app-chat (closeChat)="closeChat($event)" [showDisplay]="showChat"></app-chat>
      </div>
    </div>
  </section>

  <app-new-footer></app-new-footer>
</div>
